module.exports = __webpack_public_path__ + "static/media/left-arrow.1bf796af.svg";